module.exports = __webpack_public_path__ + "static/media/galerija_2019 (19).534753b1.jpg";